import { Modal, Checkbox, Avatar, Pagination, message, Input } from 'antd';
import { useState } from 'react';

const SelectValueUsers = ({
  isModalOpen,
  setIsModalOpen,
  selectedUsers,
  setSelectedUsers,
  userOptions,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const pageSize = 10;
    
    const handleOk = async() => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        // 可选：分页切换时保留已选值
    };
    
    // 搜索处理函数
    const handleSearch = (value) => {
        setSearchText(value);
        setCurrentPage(1); // 搜索时重置到第一页
    };
    
    // 获取过滤后的用户列表
    const getFilteredUsers = () => {
        if (!searchText.trim()) {
            return userOptions;
        }
        return userOptions.filter(user => 
            user.name.toLowerCase().includes(searchText.toLowerCase())
        );
    };
    
    // 计算当前页应该显示的用户
    const getCurrentPageUsers = () => {
        const filteredUsers = getFilteredUsers();
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return filteredUsers.slice(startIndex, endIndex);
    };
    
    const filteredUsers = getFilteredUsers();

    const handleCheckboxChange = (currentPageSelected) => {
        // 提取当前页所有用户ID（用于判断是“选中”还是“取消”）
        const currentPageAllIds = getCurrentPageUsers().map(user => user.id);
        // 计算最终选中的ID：保留非当前页的选中ID + 当前页新选中的ID
        const finalSelectedIds = [
            // 保留非当前页的原有选中ID
            ...selectedUsers.filter(user => !currentPageAllIds.includes(user.id)),
            // 追加当前页新选中的ID
            ...currentPageSelected
        ];
        // 更新选中值 + 提示
        setSelectedUsers(finalSelectedIds);
        message.success(`已选择 ${finalSelectedIds.length} 人`);
    };
    
    return (
        <Modal
        title="请选择想要value的人"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="关闭"
        okText="确认"
        >
        {/* 添加搜索框 */}
        <div style={{ marginBottom: '16px' }}>
            <Input.Search
                placeholder="搜索用户名"
                allowClear
                enterButton
                onSearch={handleSearch}
                onChange={(e) => !e.target.value && handleSearch('')}
            />
        </div>
        
        <Checkbox.Group
            value={selectedUsers}
            onChange={handleCheckboxChange}
            style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
        >
            {/* 自定义渲染每个选项：头像 + 名字 */}
            {getCurrentPageUsers().map((user) => (
            <Checkbox key={user.id} value={user}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Avatar src={user.avatar} alt={user.name} size={32} />
                <span style={{ fontSize: '14px' }}>{user.name}</span>
                </div>
            </Checkbox>
            ))}
        </Checkbox.Group>
        <div style={{ textAlign: 'center', margin: '50px 10px' }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredUsers.length}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
        </Modal>
    )
}
export default SelectValueUsers;